import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { QRCodeCanvas } from "qrcode.react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "./firebase";
import Navbar from "./Navbar";

function QrAsporto() {
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);

  const locale = String(params.get("locale") || "")
    .trim()
    .toLowerCase();

  const [url, setUrl] = useState("");
  const [loading, setLoading] = useState(true);
  const [errore, setErrore] = useState("");

  useEffect(() => {
    const generaUrlAsporto = async () => {
      if (!locale) {
        setErrore("Locale non specificato.");
        setLoading(false);
        return;
      }

      try {
        const localeRef = doc(db, "locali", locale);
        const localeSnap = await getDoc(localeRef);

        if (!localeSnap.exists()) {
          setErrore("Locale non trovato.");
          setLoading(false);
          return;
        }

        const datiLocale = localeSnap.data();

        const numeroTavoli = Number(
          datiLocale?.numeroTavoli ??
          datiLocale?.tavoli ??
          0
        );

        const haTavoliNelleSale =
          Array.isArray(datiLocale?.sale) &&
          datiLocale.sale.some(
            (sala) => Number(sala?.numeroTavoli || 0) > 0
          );

        const localeSoloAsporto =
          datiLocale?.modalitaAsporto === true &&
          numeroTavoli === 0 &&
          !haTavoliNelleSale;

        const percorso = localeSoloAsporto
          ? "menu-asporto"
          : "menu-asporto-opt";

        setUrl(
          `https://menu-qrmenu.web.app/${percorso}/${locale}`
        );
      } catch (error) {
        console.error("Errore generazione QR asporto:", error);
        setErrore("Errore durante la generazione del QR.");
      } finally {
        setLoading(false);
      }
    };

    generaUrlAsporto();
  }, [locale]);

  const copiaLink = async () => {
    if (!url) return;

    try {
      await navigator.clipboard.writeText(url);
      alert("✅ Link copiato");
    } catch {
      alert("❌ Errore copia link");
    }
  };

  return (
    <>
      <Navbar />

      <div
  style={{
    minHeight: "100dvh",
    background: "#0f0f12",
    color: "#fff",
    display: "flex",
    justifyContent: "center",
    alignItems: "flex-start",
    padding: "calc(var(--navbar-height-mobile, 56px) + 24px) 1rem 2rem",
    boxSizing: "border-box"
  }}
>
        <div
          style={{
            width: "100%",
            maxWidth: "520px",
            margin: "0 auto",
            background: "#17181d",
            borderRadius: "28px",
            padding: "2rem",
            border: "1px solid rgba(255,255,255,0.06)",
            boxShadow: "0 20px 60px rgba(0,0,0,0.45)",
            textAlign: "center"
          }}
        >
          <h1
            style={{
              marginTop: 0,
              fontSize: "2rem"
            }}
          >
            📦 QR Asporto
          </h1>

          <p
            style={{
              color: "#999",
              marginBottom: "2rem"
            }}
          >
            Scansiona il QR per aprire il menu asporto.
          </p>

          {loading ? (
            <p style={{ color: "#999" }}>
              Generazione QR...
            </p>
          ) : errore ? (
            <p style={{ color: "#ff6b6b" }}>
              {errore}
            </p>
          ) : (
            <>
              <div
                style={{
                  background: "#fff",
                  padding: "1rem",
                  borderRadius: "24px",
                  display: "inline-block"
                }}
              >
                <QRCodeCanvas
                  value={url}
                  size={280}
                  includeMargin
                />
              </div>

              <div
                style={{
                  marginTop: "1.5rem",
                  wordBreak: "break-word",
                  color: "#ff9800",
                  fontSize: "0.92rem"
                }}
              >
                {url}
              </div>

<div
  style={{
    display: "flex",
    gap: "1rem",
    marginTop: "1.5rem",
    justifyContent: "center",
    flexWrap: "wrap"
  }}
>
  <button
    onClick={copiaLink}
    style={{
      background: "#2196f3",
      color: "#fff",
      border: "none",
      borderRadius: "14px",
      padding: "0.9rem 1.2rem",
      fontWeight: "600",
      cursor: "pointer"
    }}
  >
    📋 Copia link
  </button>

  <button
    onClick={() => {
      const canvas = document.querySelector("canvas");

      if (!canvas) return;

      const qrDataUrl = canvas.toDataURL("image/png");

      const printWindow = window.open("", "_blank");

      if (!printWindow) return;

      printWindow.document.write(`
        <html>
          <head>
            <title>QR Asporto</title>
            <style>
              body {
                margin: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                min-height: 100vh;
                background: white;
              }

              img {
                width: 320px;
                height: 320px;
              }
            </style>
          </head>
          <body>
            <img src="${qrDataUrl}" />
            <script>
              window.onload = function() {
                window.print();
                window.onafterprint = function() {
                  window.close();
                };
              };
            </script>
          </body>
        </html>
      `);

      printWindow.document.close();
    }}
    style={{
      background: "#ff9800",
      color: "#fff",
      border: "none",
      borderRadius: "14px",
      padding: "0.9rem 1.2rem",
      fontWeight: "600",
      cursor: "pointer"
    }}
  >
    🖨️ Stampa solo QR
  </button>

  <button
    onClick={() => navigate(-1)}
    style={{
      background: "#2c2c2e",
      color: "#fff",
      border: "none",
      borderRadius: "14px",
      padding: "0.9rem 1.2rem",
      fontWeight: "600",
      cursor: "pointer"
    }}
  >
    ✕ Chiudi
  </button>
</div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default QrAsporto;